export const SET_HORIZONTAL_CATEGORIES = 'SET_HORIZONTAL_CATEGORIES';

export const setHorizontalCategories = (horizontalCategories: any[]) => ({
  type: SET_HORIZONTAL_CATEGORIES,
  data: horizontalCategories,
});
